import RulesetBase from "./rulesetBase";
import {ApiMetricsPermissions} from "../constants/ApiPermissions";

class MetricsRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() === ApiMetricsPermissions.read.toUpperCase()
      ) {
        can("Read", "Metrics");
        break;
      }
    }
  };
}

export default MetricsRuleset;
